"use client";

import { c as _c } from "react/compiler-runtime";
import { CollectionLockup, CollectionLockupAvatar, CollectionLockupContent, CollectionLockupFragment, CollectionLockupTitle } from "@opensea/app-kit";
import { graphql, readFragment } from "@opensea/graphql";
import { classNames, useTable } from "@opensea/ui-kit";
import { CollectionPreviewTooltip } from "@/components/collection/CollectionPreviewTooltip/CollectionPreviewTooltip";
import { CollectionPreviewTooltipFragment } from "@/components/collection/CollectionPreviewTooltip/CollectionPreviewTooltip.fragment";
import { NewCollectionChip, NewCollectionChipFragment } from "@/components/collection/NewCollectionChip";
import { collectionRecentlyMintedFragment, getIsRecentlyMinted } from "@/components/collection/utils";
export const StatsTableRowCollectionFragment = graphql(`
    fragment StatsTableRowCollection on Collection {
      ...CollectionLockup
      ...NewCollectionChip
      ...CollectionPreviewTooltip
      ...isRecentlyMinted
    }
  `, [CollectionLockupFragment, CollectionPreviewTooltipFragment, collectionRecentlyMintedFragment, NewCollectionChipFragment]);
export function StatsTableRowCollection(t0) {
  const $ = _c(18);
  const {
    collection: key
  } = t0;
  const collection = readFragment(StatsTableRowCollectionFragment, key);
  const {
    size
  } = useTable();
  const showNewChip = getIsRecentlyMinted(collection);
  const T0 = CollectionLockup;
  const t1 = "w-auto max-w-full";
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CollectionLockupAvatar />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const T1 = CollectionLockupContent;
  const t3 = "flex-row items-center justify-start gap-1.5 overflow-visible";
  const t4 = classNames("flex min-w-0 max-w-[100px] items-center gap-1.5 overflow-hidden whitespace-nowrap lg:max-w-[220px]", {
    "max-w-[80px] lg:max-w-[180px]": showNewChip
  });
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CollectionLockupTitle disableTextOverflowTooltip={true} />;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  let t7;
  if ($[2] !== collection) {
    t6 = <CollectionPreviewTooltip collection={collection}>{t5}</CollectionPreviewTooltip>;
    t7 = <NewCollectionChip collection={collection} />;
    $[2] = collection;
    $[3] = t6;
    $[4] = t7;
  } else {
    t6 = $[3];
    t7 = $[4];
  }
  let t8;
  if ($[5] !== t4 || $[6] !== t6 || $[7] !== t7) {
    t8 = <div className={t4}>{t6}{t7}</div>;
    $[5] = t4;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== T1 || $[10] !== t8) {
    t9 = <T1 className={t3}>{t8}</T1>;
    $[9] = T1;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== T0 || $[13] !== collection || $[14] !== size || $[15] !== t2 || $[16] !== t9) {
    t10 = <T0 className={t1} collection={collection} size={size}>{t2}{t9}</T0>;
    $[12] = T0;
    $[13] = collection;
    $[14] = size;
    $[15] = t2;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
}